import axios from "axios";

const accessToken = "b56bd25c0ed6cd5f12ae9b6caae9c878";

export async function getVimeoVideos(url) {
  try {
    //      const apiConfig = await getApiConfig();
    const regex = /(\d+)/g;
    const idVideo = url.match(regex);

    const req = `https://api.vimeo.com/videos/${idVideo[0]}`;

    const response = await axios.get(req, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
